'use client';
import Image from 'next/image';
import { ReactNode, useState } from 'react';
import ModalForm from '../Modal/Modal';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface ImageWithTxtBlockProps {
  title?: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  imageSrc?: string | { url: string; alt: string };
  listItems?:
    | Array<string>
    | Array<{
        item: string;
      }>;
  additionalText?: ReactNode | SerializedEditorState;
  certificateDetails?: {
    minAmount: string;
    validity: string;
  };
  buttonText?: string;
  formatDescription?: ReactNode | SerializedEditorState;
  certificateText?: ReactNode | SerializedEditorState;
  validityText?: ReactNode | SerializedEditorState;
}

export function ImageWithTxtBlock({
  title = 'Подарунковий сертифікат від AP Education',
  subtitle = 'Обирайте подарунковий сертифікат на курс англійської, німецької чи польської мови від AP Education.',
  imageSrc = '/assets/photoAP/user_sert.webp',
  listItems = [
    'дітям, щоб не нудьгували, навчаючись',
    'батькам, щоб здійснили давню мрію',
    'друзям, щоб могли подорожувати',
    'коханим, щоб знову зізнатись у почуттях',
    'знайомим, щоб і вам подарували щось потрібне',
  ],
  additionalText = 'Чи вкажіть бажану суму й ми допоможемо вам із вибором.',
  certificateDetails = {
    minAmount: '500 грн.',
    validity: '6 місяців',
  },
  buttonText = 'замовити сертифікат',
  formatDescription = 'Ви можете самостійно обрати формат занять, який найкраще підійде вашим близьким:',
  certificateText = 'Сертифікати доступні для замовлення на суму від',
  validityText = 'Термін дії —',
}: ImageWithTxtBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <div
        data-meta="ImageWithTxtBlock"
        className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:my-20"
      >
        <div className="container max-w-7xl mx-auto py-6 sm:py-4">
          <div className="mx-auto text-center">
            <CustomRichText
              data={title}
              tag="h2"
              className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
            />
            <CustomRichText
              data={subtitle}
              tag="div"
              className="mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white px-4"
            />
          </div>
        </div>
        <div className="mx-auto mt-16">
          <div className="flex flex-col items-center md:grid md:grid-cols-1 lg:grid-cols-3 lg:gap-16 gap-4">
            <Image
              width={400}
              height={550}
              src={typeof imageSrc === 'string' ? imageSrc : imageSrc.url}
              alt="Подарунковий сертифікат"
              className="w-full h-auto object-contain rounded-lg shadow-lg max-lg:order-2"
            />
            <div className="flex flex-col gap-4 col-span-2 w-full text-white">
              <CustomRichText data={formatDescription} tag="div" className="font-bold text-white" />
              <ul className="text-white list-disc list-inside">
                {listItems.map((item, index) => (
                  <li key={index}>{typeof item === 'string' ? item : item.item}</li>
                ))}
              </ul>
              <CustomRichText data={additionalText} tag="div" className="" />
              <div>
                <CustomRichText data={certificateText} tag="span" className="" />{' '}
                <span className="font-bold">{certificateDetails.minAmount}</span>
                <br />
                <CustomRichText data={validityText} tag="span" className="" />{' '}
                <span className="font-bold">{certificateDetails.validity}</span>
              </div>
              <div className="flex flex-col mt-8 p-4">
                <button
                  onClick={openForm}
                  className="uppercase text-white rounded-full py-4 px-6 sm:px-14 custom-gradient-green w-fit font-semibold"
                >
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: 'Sertificate' }} color={'green'} />
      )}
    </>
  );
}
